import React, { useEffect, useMemo } from "react"
import styles from "./ChannelTypeForm.module.scss"
import { ChannelTypeString, WhatsappChannelType } from "../../models/channel"
import { useTranslation } from "react-i18next"
import ChannelIconLarge from "../ChannelIconLarge/ChannelIconLarge"
import TypeFormCard from "../TypeFormCard/TypeFormCard"
import { useAppSelector } from "../../store/hooks"
import { useLazySearchApplicationTemplatesQuery } from "../../api/controllers/workshop"
import { selectApplicationTemplates } from "../../store/workshop/selectors"
import { ApplicationTemplate } from "../../models/workshop/template"
import { ApplicationType, TemplateVersionStatus } from "../../models/workshop/common"

const tNamespace = "channel:"

export const channelTypes: string[] = [
    ChannelTypeString.WebChat,
    ChannelTypeString.MSBot,
    ChannelTypeString.Teams,
    ChannelTypeString.Telegram,
    ChannelTypeString.Viber,
    ChannelTypeString.VK,
    WhatsappChannelType.InfoBIP,
    ChannelTypeString.Odnoklassniki,
    ChannelTypeString.Facebook,
    ChannelTypeString.Email,
    ChannelTypeString.YandexAlisa,
    ChannelTypeString.Instagram,
    ChannelTypeString.IntegrationChannel
]

interface Props {
    onSelect: (type: string, template?: ApplicationTemplate) => void
    isAppstoreEnabled?: boolean
}

const ChannelTypeForm: React.FC<Props> = props => {
    const { t } = useTranslation()
    const { onSelect, isAppstoreEnabled } = props
    const applicationTemplates = useAppSelector(selectApplicationTemplates)

    const [getApplicationTemplates] = useLazySearchApplicationTemplatesQuery()

    const sortedAppstoreChannels = useMemo(
        () => [...applicationTemplates].sort((a, b) => a.Audit.UpdateTimestamp - b.Audit.UpdateTimestamp),
        [applicationTemplates]
    )

    useEffect(() => {
        isAppstoreEnabled &&
            getApplicationTemplates({
                IsDeleted: false,
                Status: TemplateVersionStatus.PUBLISH,
                ApplicationType: ApplicationType.CHANNEL
            })
    }, [isAppstoreEnabled])

    return (
        <div className={styles.channelTypeForm}>
            <div className={styles.channelTypeForm__content}>
                {channelTypes.map(type => (
                    <TypeFormCard
                        key={type}
                        onSelect={() => onSelect(type)}
                        icon={<ChannelIconLarge type={type} className={styles.channelTypeForm__icon} />}
                        title={t(`${tNamespace}channel-type.${type}`)}
                        description={
                            type === ChannelTypeString.WebChat ? t(`${tNamespace}channel-type-desc.${type}`) : undefined
                        }
                        className={styles.channelTypeForm__card}
                        testId={`${type}-channel-type`}
                    />
                ))}
                {isAppstoreEnabled &&
                    sortedAppstoreChannels.map(template => (
                        <TypeFormCard
                            key={template.Id}
                            title={template.Title}
                            description={template.Description}
                            icon={
                                <ChannelIconLarge
                                    type={ChannelTypeString.AppstoreChannel}
                                    logo={template.Icon}
                                />
                            }
                            onSelect={() => {
                                onSelect(ChannelTypeString.AppstoreChannel, template)
                            }}
                            testId={`${ChannelTypeString.AppstoreChannel}-channel-type`}
                        />
                    ))}
            </div>
        </div>
    )
}

export default ChannelTypeForm
